import { Injectable, Inject } from '@angular/core';
import { EnvironmentPreset } from 'src/app/model/environment-preset';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentPresetService {

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private authService: AuthService) { }

  getPreset(): EnvironmentPreset {

    let env = this.authService.getEnvironment();
    if (env) { env = env.toUpperCase(); }

    const preset = new EnvironmentPreset();

    if (env === 'IVAR') {
      preset.isCT = true;
    } else {
      preset.isCT = false;
    }

    if (env === 'TCBA') {
      preset.fontName = 'Times New Roman';
      preset.startLocalPacsClient = true;
    }
    else {
      preset.startLocalPacsClient = false;
      preset.fontName = 'Arial';
    }

    if (env === 'CID' || env === 'GL') {
      preset.tinyEditor = false;
    } else   {
      preset.tinyEditor = true;
    }

    return preset;

  }
}
